import SuccessPage from './SuccessPage';

export default SuccessPage;


// WEBPACK FOOTER //
// ./src/components/pages/SuccessPage/index.js